let webChatPromise;

export const loadWebChat = () => {
  if (window.WebChat) {
    return Promise.resolve(window.WebChat);
  }

  if (!webChatPromise) {
    webChatPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.botframework.com/botframework-webchat/latest/webchat.js';
      script.async = true;
      script.onload = () => {
        if (window.WebChat) {
          resolve(window.WebChat);
        } else {
          script.remove();
          reject(new Error('Web Chat did not initialize'));
        }
      };
      script.onerror = () => {
        script.remove();
        reject(new Error('Web Chat failed to load'));
      };
      document.head.appendChild(script);
    }).catch(error => {
      webChatPromise = undefined;
      throw error;
    });
  }

  return webChatPromise;
};
